import { render, staticRenderFns } from "./BikyConfigEnabled.vue?vue&type=template&id=88167498&scoped=true&"
import script from "./BikyConfigEnabled.vue?vue&type=script&lang=ts&"
export * from "./BikyConfigEnabled.vue?vue&type=script&lang=ts&"
import style0 from "./BikyConfigEnabled.vue?vue&type=style&index=0&id=88167498&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88167498",
  null
  
)

export default component.exports